const _get = require('lodash/get');

exports.onClientEntry = () => {
  var cssVarsPonyfill = require('css-vars-ponyfill');
  cssVarsPonyfill.default();
}

exports.shouldUpdateScroll = ({
  routerProps,
  prevRouterProps,
}) => {
  const pathname = _get(routerProps, 'location.pathname', '');
  const prevPathname = _get(prevRouterProps, 'location.pathname', '');

  // prevent scroll between / and ethereum-classic
  const ethRoute = '/';
  const etcRoute = '/ethereum-classic';
  const etcRouteWithSlash = '/ethereum-classic/';
  const shouldPreventScrollOnHome = 
    (prevPathname === ethRoute && pathname === etcRoute) 
    || (prevPathname === etcRoute && pathname === ethRoute) 
    || (prevPathname === etcRouteWithSlash && pathname === ethRoute);
  if (shouldPreventScrollOnHome) {
    return false;
  }

  return true;
}